import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

import ArrowIcon from '../../../../icons/select_arrow.svg';

const SelectSimple = ({
    className,
    multiple,
    placeholder,
    options,
    hasError,
    size,
    value,
    builderInput,
    disabled,
    ...rest
}) => (
    <div className={styles.wrapper}>
        <select
            className={classNames(className, styles.root, {
                [styles.error]: hasError,
                [styles[size]]: !!styles[size],
                [styles.placeholder]: placeholder && !value,
                [styles.disabled]: disabled,
                [styles.builderInput]: builderInput,
            })}
            multiple={multiple}
            value={value}
            disabled={disabled}
            data-value={value}
            {...rest}
        >
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((option) => (
                <option key={option.value} value={option.value} disabled={option.disabled}>
                    {option.label}
                </option>
            ))}
        </select>
        <ArrowIcon color={rest.style?.color} className={styles.arrowIcon} />
    </div>
);

SelectSimple.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string,
        })
    ).isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    hasError: PropTypes.bool,
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
    elementStyle: PropTypes.string,
    size: PropTypes.oneOf(['normal', 'small']),
    builderInput: PropTypes.bool,
};

SelectSimple.defaultProps = {
    builderInput: false,
    hasError: false,
    multiple: false,
};

export default SelectSimple;
